import './App.css';
import Header from './Header';
import Navbar from './Navbar';

function App() {
  return (
    <div>
      <Navbar/>
      <Header/>
    </div>
  );
}

export default App;
